<template>
    <div v-if="showEmpty || files.length > 0">
        <div
            v-if="showEmpty || images.length > 0"
            :class="{
                'mb-4': showEmpty || not_images.length > 0
            }"
        >
            <div class="mb-2 text-label">
                Images
            </div>

            <grid-layout v-if="images.length > 0">
                <grid-layout-item
                    v-for="file in images"
                    :key="file.uuid"
                    class="w-1/4"
                >
                    <file-modal
                        :file="file"
                        class="w-full border rounded"
                    >
                        <img-aspect-ratio
                            :src="$laroute.route('storage.files.show', {
                                file: file.uuid,
                                width: '200',
                            })"
                            aspect-ratio="4/3"
                        />
                    </file-modal>
                </grid-layout-item>
            </grid-layout>

            <base-na v-else />
        </div>

        <template v-if="not_images.length > 0">
            <div class="mb-2 text-label">
                Files
            </div>

            <div
                v-if="not_images.length > 0"
                class="bg-white border rounded"
            >
                <files-table :files="not_images" />
            </div>

            <base-na v-else />
        </template>
    </div>
</template>

<script>
    import _ from 'lodash'
    import FilesTable from './files-table'

    export default {
        components: {
            FilesTable
        },
        props: {
            files: {
                type: Array,
                required: true
            },
            showEmpty: {
                type: Boolean,
                default: true
            }
        },
        computed: {
            images () {
                return _.filter(this.files, {
                    is_image: true
                })
            },
            not_images () {
                return _.filter(this.files, {
                    is_image: false
                })
            }
        }
    }
</script>
